import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const KEY = "btp_reminder";
const todayKey = () => new Date().toLocaleDateString("sv-SE");

export const getReminder = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || { enabled: false, time: "18:00" };
  } catch {
    return { enabled: false, time: "18:00" };
  }
};
export const saveReminder = (r) => localStorage.setItem(KEY, JSON.stringify(r));

async function check() {
  const r = getReminder();
  if (!r.enabled || r.lastShown === todayKey()) return;
  const now = new Date();
  const [h, m] = r.time.split(":").map(Number);
  if (now.getHours() * 60 + now.getMinutes() < h * 60 + m) return;
  const { data } = await api.get("/progress");
  saveReminder({ ...getReminder(), lastShown: todayKey() });
  if (data.today.lesson_done) return;
  const body = data.streak > 0 ? `Votre série de ${data.streak} jour(s) vous attend. 5 minutes suffisent !` : "5 minutes pour la leçon du jour !";
  if (!r.push && "Notification" in window && Notification.permission === "granted") {
    new Notification("Français Chantier", { body });
  }
  toast.warning("Rappel : leçon du jour", { description: body, duration: 10000 });
}

export function useDailyReminder() {
  useEffect(() => {
    check().catch(() => {});
    const id = setInterval(() => check().catch(() => {}), 60000);
    return () => clearInterval(id);
  }, []);
}
